import * as firebase from 'firebase';

firebase.initializeApp({
  apiKey: "AIzaSyDTkBw2kNhcgZ0CiNHfWlA43bVgfEE1XQE",
  authDomain: "myhandyplus-66863.firebaseapp.com",
  databaseURL: "https://myhandyplus-66863.firebaseio.com",
  projectId: "myhandyplus-66863",
  storageBucket: "myhandyplus-66863.appspot.com",
  messagingSenderId: "1099099676479",
  appId: "1:1099099676479:web:138f26cbbd0be309b2bd8a",
  measurementId: "G-DHJ6THFXRM"
});
export const authRef = firebase.auth();



// WEBPACK FOOTER //
// ./src/reference.js